import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export type UseOnboardingNavigateResult = {
  navigateTo: (path: string, state?: Record<string, unknown>) => void;
  isNavigating: boolean;
};

export function useOnboardingNavigate(): UseOnboardingNavigateResult {
  const navigate = useNavigate();
  const [isNavigating, setIsNavigating] = useState(false);

  useEffect(() => {
    return () => {
      setIsNavigating(false);
    };
  }, []);

  const navigateTo = useCallback(
    (path: string, state?: Record<string, unknown>) => {
      setIsNavigating(true);
      if (state !== undefined) {
        navigate(path, { state });
      } else {
        navigate(path);
      }
    },
    [navigate],
  );

  return { navigateTo, isNavigating };
}
